export const environment = {
    production: false,
    api: 'https://app.demo.spiritsrim.com',
};